import { ReactNode } from "react";
import { StatusBadge, StatusBadgeVariant } from "components/StatusBadge";
import {
  StatusPagamentoTaxa,
  StatusPagamentoTaxaLabel,
} from "./enums/StatusPagamentoTaxa.enum";

interface IProps {
  status?: number | null;
  width?: string;
  popover?: ReactNode;
}

const variantePorStatus: Record<number, StatusBadgeVariant> = {
  [StatusPagamentoTaxa.PENDENTE]: "aviso",
  [StatusPagamentoTaxa.PAGO]: "sucesso",
  [StatusPagamentoTaxa.MANUAL]: "info",
  [StatusPagamentoTaxa.PROCESSANDO]: "neutro",
  [StatusPagamentoTaxa.ERRO]: "erro",
  [StatusPagamentoTaxa.CANCELADO]: "rosa",
  [StatusPagamentoTaxa.DEBITOS_ADICIONAIS]: "roxo",
};

export function StatusItemPagamento({ status, width, popover }: IProps) {
  const s = status ?? StatusPagamentoTaxa.PENDENTE;
  const texto =
    StatusPagamentoTaxaLabel[s] ??
    StatusPagamentoTaxaLabel[StatusPagamentoTaxa.PENDENTE];
  const variant = variantePorStatus[s] ?? "aviso";
  return (
    <StatusBadge
      label={texto}
      variant={variant}
      width={width}
      popover={popover}
    />
  );
}
